<template>
  <div class="institutes mt-24-md">
    <div class="institutes__buttons">
      <router-link to="/catalog" class="btn btn-lg">
        <span class="d-flex align-center">
          <img src="../assets/icons/recover.svg" />
          <span>{{ $t('buttons.startLearning') }}</span>
        </span>
      </router-link>
      <router-link to="/catalog" class="btn btn-lg btn-without-border color-grey lg-visible">
        <span class="d-flex align-center">
          <span>{{ $t('buttons.viewAllCourses') }}</span>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainPageInstituteList"

}
</script>

<style lang="scss">
.institutes {
  &__buttons {
    padding: 40px 0;
    text-align: center;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .logo-block {
    margin-top: 32px;
    padding: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
</style>